import React, { useEffect } from 'react'
import { Switch, Table, Tooltip } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { useInquiryModel } from '../inquiryModel'
import { IInquiryDetail } from '../inquiryTypes'
import YhTootip from '@/components/YhTootip'
import { inquiryStatusOption } from '@/types/supplierDs'

export function DataTable() {
    const { dataSource, selectedRowKeys, pgCfg, loading, loadData, setSelectedRowKeys, onEnableChange } = useInquiryModel()

    useEffect(() => {
        loadData()
    }, [])

    const columns: ColumnsType<IInquiryDetail> = [
        {
            title: '序号',
            width: 40,
            align: 'left',
            fixed: 'left',
            render: (t, r, i) => i + 1,
        },
        {
            title: '询价单号',
            width: 140,
            align: 'left',
            dataIndex: 'inquiryCode',
            render: (text: string) => <YhTootip text={text} />,
        },
        {
            title: '单据状态',
            width: 140,
            align: 'left',
            dataIndex: 'status',
            // inquiryStatusOption
            render: (text: string) =>  <YhTootip text={ inquiryStatusOption.find(i => i.value === text)?.label || ''} />,
        },
        {
            title: '供应商名称',
            width: 140,
            align: 'left',
            dataIndex: 'supplierName',
            render: (text: string) => <YhTootip text={text} />,
        },
        {
            title: '询价人',
            width: 140,
            align: 'left',
            dataIndex: 'createUser',
            render: (text: string) => <YhTootip text={text} />,
        },
        {
            title: '报价人',
            width: 140,
            align: 'left',
            dataIndex: 'quotationOfficer',
            render: (text: string) => <YhTootip text={text} />,
        },
        {
            title: '备注',
            width: 140,
            align: 'left',
            dataIndex: 'note',
            render: (text: string) => <YhTootip text={text} />,
        },
        {
            title: '制单日期',
            width: 240,
            align: 'left',
            dataIndex: 'createTime',
            render: (text: string) => <YhTootip text={text} />,
        }
    ]


    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id)
        let newSelectedRowKeys = [...selectedRowKeys]
        if (findIndex === -1) {
            newSelectedRowKeys.push(id)
            setSelectedRowKeys(newSelectedRowKeys)
        } else {
            newSelectedRowKeys.splice(findIndex, 1)
            setSelectedRowKeys(newSelectedRowKeys)
        }
    }

    return (
        <Table
            rowKey={(record) => record.id}
            loading={loading}
            rowSelection={{
                //全部选中时  (存string[])
                onSelectAll: (selected, selectedRows, changeRows) => {
                    let changeRowId = changeRows.map((item) => item.id)
                    selected
                        ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
                        : setSelectedRowKeys((origin) => origin.filter((item) => changeRowId.indexOf(item) < 0))
                },
                onSelect: (record) => onRow(record.id),
                selectedRowKeys: selectedRowKeys,
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ['bottomCenter'],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                },
            }}
            onRow={(record) => ({
                onClick: () => onRow(record.id),
                onContextMenu: (e) => {
                    e.preventDefault()
                    setSelectedRowKeys([record.id])
                },
            })}
            scroll={{ x: 'max-content', y: 'calc(100vh - 446px)' }}
        />
    )
}
